import axios from 'axios';
import { environment } from '../environments/environment';

export const medtechClient = axios.create({
  baseURL: environment.mtbeEndpoint,
  withCredentials: true,
});
